<div #mapDetailsContainer class="ggc-map-details-container">
  <ng-content></ng-content>
</div>
